export default __webpack_public_path__ + "static/media/x-ray.73a61338.jpg";